import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('extract_data_from_image__no_manual_entry_needed'),
    description: defineMessage('free_documents'),
    tryNowButtonText: defineMessage('start_automating'),
};
